// extracted by mini-css-extract-plugin
export default {"container":"redeemTooltip_container__VLC4g","tooltipContainer":"redeemTooltip_tooltipContainer__5nPXU","tooltip":"redeemTooltip_tooltip__wqmXO"};